import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./booking-carousel.css";

const BookingCarousel = () => {
  const scrollRef = useRef(null);

  const scrollOne = (direction) => {
    const container = scrollRef.current;
    if (!container) return;

    const card = container.querySelector(".carousel-card");
    if (!card) return;

    const cardWidth = card.offsetWidth + 20;

    container.scrollBy({
      left: direction === "right" ? cardWidth : -cardWidth,
      behavior: "smooth",
    });
  };

  return (
    <div className="carousel-wrapper">
      {/* Left Button */}
      <button
        className="nav-btn nav-left"
        onClick={() => scrollOne("left")}
      >
        ‹
      </button>

      {/* Right Button */}
      <button
        className="nav-btn nav-right"
        onClick={() => scrollOne("right")}
      >
        ›
      </button>

      {/* Scroll Container */}
      <div className="carousel-container" ref={scrollRef}>

        {/* 1 */}
        <a href="https://www.google.com" className="carousel-card">
        <div className="carousel-card-">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 01</h6>
          <div className="card-action">Book Now</div>
        </div>
        </a>

        {/* 2 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 02</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 3 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 03</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 4 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 04</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 5 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 05</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 6 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 06</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 7 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 07</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 8 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 08</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 9 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 09</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 10 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 10</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 11 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 11</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 12 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 12</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 13 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 13</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 14 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 14</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 15 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 15</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 16 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 16</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 17 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 17</h6>
          <div className="card-action">Book Now</div>
        </div>

        {/* 18 */}
        <div className="carousel-card">
          <img src="./images/booking.png" alt="Booking" className="card-image" />
          <h6 className="card-title">Prathishta 18</h6>
          <div className="card-action">Book Now</div>
        </div>

      </div>
    </div>
  );
};

export default BookingCarousel;
    